<template>
  <div v-if="subscription !== null" class="modal-mask">
    <revocation-defense
      :voucher-data="subscription"
      :close="clickClose"
      :user-service-id="subscription.userserviceid"
      :end-date="subscription.enddate"
      :is-unsubscribe="isUnsubscribe"
    />
  </div>
</template>

<script>
  import RevocationDefense from '@/components/lnb/mypooq/popup/RevocationDefense'
  import { get } from 'lodash'
  export default {
    name: 'PopupRevocationDefense',
    components: {
      RevocationDefense,
    },
    data() {
      return {
        subscription: null,
        isUnsubscribe: null, // 해지 방어 팝업용 플래그 true: 1차 해지방어, false: 2차 해지방어
      }
    },
    created() {
      this.subscription = get(this.$route, ['params', 'subscription'], null)
      this.isUnsubscribe = get(this.$route, ['params', 'isUnsubscribe'], true)
      if (this.subscription !== null) {
        sessionStorage.setItem(
          'revocationDefenseInfo',
          JSON.stringify(
            Object.assign(
              {},
              { isUnsubscribe: this.isUnsubscribe },
              { subscription: this.subscription },
            ),
          ),
        )
      } else {
        const revocationDefenseInfo = JSON.parse(
          sessionStorage.getItem('revocationDefenseInfo'),
        )
        this.subscription = get(revocationDefenseInfo, 'subscription', {})
        this.isUnsubscribe = get(revocationDefenseInfo, 'isUnsubscribe', false)
      }
    },
    methods: {
      clickClose() {
        this.$router.back()
      },
    },
  }
</script>

<style lang="css">
  .modal-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 5000;
  }

  .modal-mask .defend-wrap {
    width: 100%;
    /*min-height: 100%;*/
    min-height: 100vh;
  }

  /* 해지방어 */
  .defend-wrap {
    width: 100%;
    background-color: #252525;
    position: relative;
  }

  .defend-wrap .defend-close {
    position: absolute;
    top: 0;
    right: 0;
  }

  .defend-wrap .defend-close > img {
    width: 36px;
  }

  .defend-wrap .defend-top {
    background-color: #f66ca7;
    color: #fff;
  }

  .defend-wrap .defend-info01 {
    padding: 40px 20px 30px;
    font-size: 0;
    text-align: center;
  }

  .defend-wrap .defend-info02 {
    padding: 4px 20px 9px;
  }

  .defend-wrap h1 {
    margin: 8px 0;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .defend-wrap .defend-top > img {
    margin: 0 0 20px;
    width: 44px;
  }

  .defend-wrap .defend-top .coin-info {
    margin: 0 0 16px;
    width: 160px;
  }

  .defend-wrap .defend-top > p {
    font-size: 14px;
    line-height: 18px;
  }

  .defend-wrap .defend-top > p.coin-text {
    color: #fff;
  }

  .defend-wrap .step1 .coin-text {
    font-size: 14px;
    line-height: 18px;
  }

  .defend-wrap .step2 .coin-text {
    font-size: 16px;
    line-height: 26px;
  }

  .defend-wrap .defend-top .coin-text span {
    display: block;
  }

  .defend-wrap .defend-top .coin-text strong {
    font-weight: 700;
  }

  .defend-wrap .coin-text1 {
    display: block;
    margin-top: 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .defend-wrap .step2 .coin-text1 {
    font-weight: 700;
  }

  .defend-wrap .coin-text2 {
    display: block;
    font-size: 12px;
    line-height: 18px;
    color: #717171;
  }

  .defend-wrap .defend-top > p.coin-text b {
    font-size: 20px;
    font-weight: 700;
  }

  .defend-wrap .defend-contents {
    padding: 30px 20px 50px 20px;
    overflow: hidden;
  }

  .defend-wrap .defend-contents .terms-list {
    margin-top: 30px;
  }

  .defend-wrap .defend-contents .terms-list .terms-item {
    position: relative;
    font-size: 12px;
    line-height: 20px;
    color: #5e5e5e;
    padding-left: 12px;
  }

  .defend-wrap .defend-contents .terms-list .terms-item:before {
    position: absolute;
    content: '•';
    height: 100%;
    top: 0;
    left: 0;
  }

  .defend-wrap .defend-contents .bottom-button-container {
    display: flex;
    padding: 20px 0;
  }

  .defend-wrap .defend-contents .bottom-button-container .btn-pink {
    flex: 1;
    margin: 0;
  }

  .defend-wrap .defend-contents .bottom-button-container .btn-pink.mr-8 {
    margin-right: 8px;
  }

  .defend-wrap .defend-type01 {
    padding-top: 50px;
  }

  .defend-wrap .con-tit {
    display: block;
    margin: 0 0 10px;
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
    font-weight: 700;
  }

  .defend-wrap .con-dotted {
    display: block;
    font-size: 14px;
    line-height: 18px;
    padding-left: 9px;
    text-indent: -9px;
    margin: 0 0 6px;
    color: #a5a5a5;
  }

  .defend-wrap .con-dotted.tal {
    color: #717171;
  }

  .defend-wrap .con-dotted .icon-dotted {
    display: inline-block;
    background-color: #a5a5a5;
    border-radius: 50%;
    width: 2px;
    height: 2px;
    margin: 0 6px 0 0;
    vertical-align: middle;
  }

  .defend-wrap .con-dotted.tal .icon-dotted {
    margin: 0 3px 0 0;
    background-color: #717171;
  }

  .defend-wrap.tac .con-dotted,
  .defend-wrap.tac .con-dotted .icon-dotted {
    color: #717171;
  }

  .defend-wrap .con-dotted.pink-dotted em {
    background: #eb2e80;
  }

  .defend-wrap .con-txt {
    display: block;
    margin: 20px 0;
    font-size: 12px;
    line-height: 18px;
    color: #717171;
    text-align: center;
  }

  .defend-wrap .con-txt strong {
    display: inline-block;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }

  .defend-wrap .con-txt01 {
    margin: 6px 0 30px;
  }

  .defend-wrap .con-txt02 {
    font-size: 11px;
    margin: 10px 0 0;
  }

  .defend-wrap .btn-pink {
    margin: 40px 0 20px;
  }

  .defend-wrap .btn-pink a {
    display: block;
    background: #f66ca7;
    width: 100%;
    border-radius: 100px;
    height: 45px;
    color: #fff;
    line-height: 44px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
  }

  .defend-wrap .gray-arrow {
    display: block;
    text-align: right;
    font-size: 14px;
    line-height: 20px;
    color: #717171;
  }
  .defend-wrap .gray-arrow span,
  .defend-wrap .gray-arrow svg {
    display: inline-block;
    vertical-align: middle;
  }

  .defend-wrap .gray-arrow span {
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }

  .defend-wrap .gray-arrow svg {
    margin-left: 2px;
    font-size: 12px;
    line-height: 12px;
  }

  .defend-wrap .reason-list li {
    margin: 0 0 8px;
  }

  .defend-wrap .reason-list li:first-child {
    padding: 10px 0 0;
  }

  .defend-wrap .reason-list li:last-child {
    padding: 0 0 10px;
  }

  .defend-wrap .reason-list li label {
    color: #23212a;
    font-size: 13px;
  }

  .defend-wrap .reason-list li textarea {
    border-radius: 6px;
    width: calc(100% - 2px);
    padding: 15px;
    font-size: 13px;
    border: 1px solid #e5e5e5;
  }

  .defend-wrap .reason-list li textarea:focus {
    border: 1px solid #f66ca7 !important;
  }

  .defend-wrap .ticket-table {
    border: 1px solid #717171;
    width: 100%;
    padding: 10px 0;
    font-size: 14px;
    color: #a5a5a5;
  }

  .defend-wrap .ticket-table table {
    width: 100%;
  }

  .defend-wrap .ticket-table th,
  .defend-wrap .ticket-table td {
    padding: 10px;
    vertical-align: top;
  }

  .defend-wrap .ticket-table th {
    width: 92px;
    padding: 10px 20px;
  }

  .defend-wrap .marB0 {
    margin-bottom: 0;
  }

  .defend-wrap .marT30 {
    margin-top: 30px;
  }

  .defend-wrap .gray-back {
    background: #f6f6f6;
    border-radius: 6px;
    padding: 1px 20px;
  }

  .defend-wrap .two-btn {
    width: 100%;
    overflow: hidden;
    margin: 40px 0 0;
  }

  .defend-wrap .two-btn > div {
    width: 49%;
    width: -webkit-calc(50% - 5px);
    width: -moz-calc(50% - 5px);
    width: calc(50% - 5px);
  }

  .defend-wrap .btn-line,
  .defend-wrap .btn-purple {
    display: block;
    height: 45px;
    line-height: 44px;
    font-size: 13px;
    border-radius: 100px;
    width: 100%;
  }

  .defend-wrap .btn-line {
    border: solid 1px #1351f9;
    color: #23212a;
  }

  .defend-wrap .btn-purple {
    background: #1351f9;
    color: #fff;
  }

  .defend-wrap .fc-pink {
    color: #f66ca7;
    font-weight: 400;
  }

  /* 해지방어 코인 수령 후 해지 재신청 불가기간 연장 */
  .revocation-exclamation {
    padding-left: 10px;
    margin-bottom: 10px;
    color: #717171;
    font-size: 12px;
    line-height: 18px;
  }
  .revocation-exclamation span {
    position: relative;
    display: block;
  }
  .revocation-exclamation span:before {
    position: absolute;
    left: -10px;
    content: '\B7';
  }
  .defend-pop-wrap .revocation-link {
    display: block;
    text-align: right;
  }
</style>
